import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys } from "vue"
import _imports_0 from '../../assets/team-effectiveness/otter-gif-2.gif'
import _imports_1 from '../../assets/team-effectiveness/chameleon-gif-2.gif'


const _hoisted_1 = {
  key: 0,
  class: "team-effectiveness-questionnaire",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xs-12" }
const _hoisted_6 = { class: "question-text text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"60px"} }, null, -1)
const _hoisted_8 = {
  class: "answer",
  style: {"width":"100%"}
}
const _hoisted_9 = {
  key: 0,
  class: "scale"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Strongly "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" disagree")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Disagree", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Agree", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Strongly "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" agree")
], -1)
const _hoisted_14 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "scale"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Not close ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Very close", -1)
const _hoisted_20 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  class: "question",
  key: "cherish"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_23 = ["onClick", "onKeydown", "data-id"]
const _hoisted_24 = { class: "ter-pick-answer" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "pick-question-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_27 = {
  class: "question",
  key: "change"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_29 = ["onClick", "onKeydown", "data-id"]
const _hoisted_30 = { class: "ter-pick-answer" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "pick-question-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_33 = { class: "ter-bottom-nav clearfix" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]

import { ref, onMounted, computed, triggerRef } from "vue";
import VueSlider from "vue-3-slider-component";
import cms from "../../services/cms/cms";
import {
  CmsDocumentTypes,
  CmsRichText,
  CmsTeamEffectivenessReview,
} from "../../services/cms/cms-type-definitions";
import cmsContentMap from "../../services/cms/cms-content-map";
import { TeamEffectivenessRatingsApiModel } from "../../api-models";

// import "vue-slider-component/dist-css/vue-slider-component.css";
// import "vue-slider-component/theme/default.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-effectiveness-questionnaire',
  props: {
    isSubmitting: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const questionIndex = ref(0);

const answers = ref([5.5]);

const doc = ref<CmsTeamEffectivenessReview | null>(null);

const cherishAnswerId = ref<string | null>(null);

const changeAnswerId = ref<string | null>(null);

function useAlternateScale(index: number): boolean {
  return doc.value?.data.body[index].primary.question_id === "Potential";
}

function questionTitle(index: number): string {
  return cms.asText(doc.value?.data.body[index].primary.question_title);
}

function questionClass(index: number): string {
  const question_id = doc.value?.data.body[index].primary.question_id;
  if (question_id) {
    return `ter-${doc.value?.data.body[index].primary.question_id.toLowerCase()}`;
  }

  return "";
}

function cherishHtml(): string {
  return cms.asHtml(doc.value?.data.cherish_question_text);
}

function changeHtml(): string {
  return cms.asHtml(doc.value?.data.change_question_text);
}

function ratingQuestionHtml(): string {
  return cms.asHtml(doc.value?.data.rating_question_text);
}

const pickOptions = computed(() => {
  return doc.value?.data.body
    .filter(
      // This line removes the final question from the pick options.
      (q) => !!q.primary.question_id && q.primary.question_id !== "Potential",
    )
    .map((q) => {
      return {
        id: q.primary.question_id,
        text: q.primary.question_title,
      };
    });
});

const currentAnswer = computed({
  get: () => answers.value[questionIndex.value],
  set: (value: number) => {
    answers.value[questionIndex.value] = value;
    triggerRef(answers);
  },
});

const showTooltip = computed(() => answers.value[questionIndex.value] !== 5.5);

const canPrev = computed(() => questionIndex.value > 0);

function prev(): void {
  if (canPrev.value) {
    questionIndex.value -= 1;
  }
}

const isLastQuestion = computed(() => {
  return questionIndex.value === answers.value.length - 1 + 2;
});

const canSubmit = computed(() => {
  return isLastQuestion.value && !!changeAnswerId.value && !props.isSubmitting;
});

const isRatingQuestion = computed(() => {
  return questionIndex.value <= answers.value.length - 1;
});

const isPickingQuestion = computed(() => {
  return questionIndex.value > answers.value.length - 1;
});

const isCherishQuestion = computed(() => {
  return questionIndex.value === answers.value.length - 1 + 1;
});

const isChangeQuestion = computed(() => {
  return questionIndex.value === answers.value.length - 1 + 2;
});

function selectCherishAnswer(questionId: string): void {
  cherishAnswerId.value = questionId === cherishAnswerId.value ? null : questionId;
}

function selectChangeAnswer(questionId: string): void {
  changeAnswerId.value = questionId === changeAnswerId.value ? null : questionId;
}

function questionGuidanceText(): string {
  if (isCherishQuestion.value) {
    return cherishHtml();
  }
  if (isChangeQuestion.value) {
    return changeHtml();
  }
  return ratingQuestionHtml();
}

const canNext = computed(() => {
  return (
    (!isLastQuestion.value &&
      isRatingQuestion.value &&
      answers.value[questionIndex.value] !== 5.5) ||
    (isCherishQuestion.value && !!cherishAnswerId.value) ||
    (isChangeQuestion.value && !!changeAnswerId.value)
  );
});

function next(): void {
  if (canNext.value) {
    questionIndex.value += 1;
  }
}

function submit(): void {
  if (canSubmit.value) {
    // Create a dictionary/hash of question IDs/answers
    const ratings = doc.value?.data.body.reduce((obj, question, index) => {
      obj[question.primary.question_id] = answers.value[index];
      return obj;
    }, {});
    const rawRatings = {
      ratings,
      cherishQuestionId: cherishAnswerId.value,
      changeQuestionId: changeAnswerId.value,
    } as TeamEffectivenessRatingsApiModel;
    emit("submit", rawRatings);
  }
}

onMounted(() => {
  cms
    .getById(
      CmsDocumentTypes.CmsTeamEffectivenessReview,
      cmsContentMap.teamEffectiveness.questionnaireQuestions,
    )
    .then((d) => {
      doc.value = d;
      answers.value = d.data.body.map(() => 5.5);
    });
});

return (_ctx: any,_cache: any) => {
  return (doc.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["col-sm-12", isCherishQuestion.value ? 'cherish' : isChangeQuestion.value ? 'change' : '']),
            innerHTML: questionGuidanceText(),
            style: {"margin-bottom":"10px"}
          }, null, 10, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (isRatingQuestion.value)
              ? (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["question", questionClass(questionIndex.value)]),
                  key: questionIndex.value
                }, [
                  _createElementVNode("h3", _hoisted_6, _toDisplayString(questionTitle(questionIndex.value)), 1),
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(VueSlider), {
                      ref: "slider",
                      min: 1,
                      max: 10,
                      interval: 1,
                      lazy: true,
                      piecewise: true,
                      speed: 0.3,
                      tooltip: showTooltip.value ? 'always' : 'none',
                      "dot-size": 40,
                      marks: true,
                      "mark-size": 20,
                      absorb: true,
                      modelValue: currentAnswer.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentAnswer).value = $event))
                    }, null, 8, ["tooltip", "modelValue"]),
                    (!useAlternateScale(questionIndex.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_14))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_20))
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (isCherishQuestion.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("ul", {
                    class: _normalizeClass(["ter-pick-answers", cherishAnswerId.value ? 'selection-made' : 'no-selection']),
                    style: {"width":"100%"}
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pickOptions.value, (question, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        onClick: ($event: any) => (selectCherishAnswer(question.id)),
                        onKeydown: _withKeys(($event: any) => (selectCherishAnswer(question.id)), ["space"]),
                        key: question.id,
                        class: _normalizeClass([questionClass(index), { selected: cherishAnswerId.value == question.id }]),
                        "data-id": question.id
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["ter-pick-answer-checkbox hidden-xs glyphicon", 
                    cherishAnswerId.value == question.id ? 'glyphicon-check' : 'glyphicon-unchecked'
                  ])
                          }, null, 2),
                          _createElementVNode("span", {
                            class: "ter-pick-answer-text",
                            innerHTML: _unref(cms).asText(question.text)
                          }, null, 8, _hoisted_25)
                        ])
                      ], 42, _hoisted_23))
                    }), 128))
                  ], 2),
                  _hoisted_26
                ]))
              : _createCommentVNode("", true),
            (isChangeQuestion.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("ul", {
                    class: _normalizeClass(["ter-pick-answers", changeAnswerId.value ? 'selection-made' : 'no-selection']),
                    style: {"width":"100%"}
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pickOptions.value, (question, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        onClick: ($event: any) => (selectChangeAnswer(question.id)),
                        onKeydown: _withKeys(($event: any) => (selectChangeAnswer(question.id)), ["space"]),
                        key: question.id,
                        class: _normalizeClass([questionClass(index), { selected: changeAnswerId.value == question.id }]),
                        "data-id": question.id
                      }, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["ter-pick-answer-checkbox hidden-xs glyphicon", changeAnswerId.value == question.id ? 'glyphicon-check' : 'glyphicon-unchecked'])
                          }, null, 2),
                          _createElementVNode("span", {
                            class: "ter-pick-answer-text",
                            innerHTML: _unref(cms).asText(question.text)
                          }, null, 8, _hoisted_31)
                        ])
                      ], 42, _hoisted_29))
                    }), 128))
                  ], 2),
                  _hoisted_32
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_33, [
              (canPrev.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary btn-lg",
                    style: {"margin":"10px","float":"left","margin-left":"0"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (prev())),
                    type: "button"
                  }, " Prev "))
                : _createCommentVNode("", true),
              (!isLastQuestion.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-primary btn-lg",
                    style: {"margin":"10px","float":"right","margin-right":"0"},
                    disabled: !canNext.value,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (next())),
                    type: "button"
                  }, " Next ", 8, _hoisted_34))
                : _createCommentVNode("", true),
              (isLastQuestion.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-primary btn-lg",
                    style: {"margin":"10px","float":"right","margin-right":"0"},
                    disabled: !canSubmit.value,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (submit())),
                    type: "button"
                  }, " Submit ", 8, _hoisted_35))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})